import { render } from "./FormMultiSelect2FieldComponent.vue?vue&type=template&id=5a0abee0&scoped=true"
import script from "./FormMultiSelect2FieldComponent.vue?vue&type=script&lang=js"
export * from "./FormMultiSelect2FieldComponent.vue?vue&type=script&lang=js"

import "./FormMultiSelect2FieldComponent.vue?vue&type=style&index=0&id=5a0abee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0abee0"]])

export default __exports__